<div [formGroup]="form">
  <div class="lrc-container-fields">
    <app-input-vocabulary-autocomplete
      formControlName="LRCS"
      #LRCSElement
      [vocabularyName]="'V_PRV'"
      [openVocabulary]="false"
      [parentTerm]="null"
      [placeholder]="'Stato (LRCS)'">
    </app-input-vocabulary-autocomplete>
    <app-input-vocabulary-autocomplete
      #LRCRElement
      formControlName="LRCR"
      [vocabularyName]="'V_PRV'"
      [parentTerm]="LRCSElement?.extendedValue"
      [openVocabulary]="false"
      [placeholder]="'Regione (LRCR)'">
    </app-input-vocabulary-autocomplete>
    <app-input-vocabulary-autocomplete
      #LRCPElement
      formControlName="LRCP"
      [vocabularyName]="'V_PRV'"
      [parentTerm]="LRCRElement?.extendedValue"
      [openVocabulary]="false"
      [placeholder]="'Provincia (LRCP)'">
    </app-input-vocabulary-autocomplete>
    <app-input-vocabulary-autocomplete
      formControlName="LRCC"
      [vocabularyName]="'V_PRV'"
      [parentTerm]="LRCPElement?.extendedValue"
      [openVocabulary]="false"
      [placeholder]="'Comune (LRCC)'">
    </app-input-vocabulary-autocomplete>

    <mat-form-field>
      <input
        matInput
        placeholder="Località (LRCL)"
        formControlName="LRCL">
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        placeholder="Località estera (LRCE)"
        formControlName="LRCE">
    </mat-form-field>
  </div>
</div>
